import React, { Component } from 'react';
import { jsonParse } from '../Libraries/helpers';
import Spinner from '../Libraries/Loader';

const quantities = [];

for (let i = 1; i <= 9; i++) {
    quantities.push({
        label: i,
        value: i,
    })
}

quantities.push({
    label: '10+',
    value: '10+',
})

class PurchaseOptions extends Component {
    constructor(props) {
        super(props);
        this.config = jsonParse(props.config);
        this.handleOnChange = this.handleOnChange.bind(this);

        this.state = {
            model: this.config.models[0].value,
            quantity: quantities[0].value,
            isHovering: false,
            busy: false,
        };
    }

    handleMouseEnter = () => this.setState({isHovering: true})

    handleMouseLeave = () => this.setState({isHovering: false})

    handleOnChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }

    enquire(location) {
        const url = new URL(location)

        if (this.config.brandId) {
            url.searchParams.set('brand', this.config.brandId)
        }

        url.searchParams.set('product', this.config.product)
        url.searchParams.set('model', this.state.model)
        url.searchParams.set('quantity', this.state.quantity)

        window.location = url.toString()
    }

    render() {
        return <>
            <div>
                <div className="flex flex-wrap">

                    <div className="w-full lg:flex-1">
                        <div className="js-form-label small-label">
                            <div className="relative">
                                <label htmlFor="model_select">
                                    {this.config.i18n.model} <span style={{ color: '#C90600' }}>*</span>
                                </label>

                                <select
                                    required={true}
                                    className="styled-input-alt"
                                    id="model_select"
                                    name="model"
                                    onChange={this.handleOnChange}
                                    value={this.state.model}
                                >
                                    {this.config.models.map((option) => (
                                        <option key={option.key || option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="w-full mt-8 lg:mt-0 lg:w-24 lg:ml-4">
                        <div className="js-form-label small-label">
                            <div className="relative">
                                <label htmlFor="quantity_select">
                                    {this.config.i18n.quantity} <span style={{ color: '#C90600' }}>*</span>
                                </label>

                                <select
                                    required={true}
                                    className="styled-input-alt"
                                    id="quantity_select"
                                    name="quantity"
                                    onChange={this.handleOnChange}
                                    value={this.state.quantity}
                                >
                                    {quantities.map((option) => (
                                        <option key={option.key || option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-wrap mt-4 lg:mt-6">
                    <div className="w-full lg:w-1/2 lg:pr-2">
                        <button
                            value={this.config.purchaseUrl}
                            onClick={e => {
                                this.setState({busy: true});
                                this.enquire(e.target.value);
                            }}
                            className="border border-solid border-green h-11 px-4 sm:px-10 rounded-sm w-full text-center text-sm leading-snug inline-flex justify-center items-center relative transition duration-300 ease-linear bg-green text-white md:text-[0.9375rem] hover:bg-black hover:border-black"
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}
                            disabled={this.state.busy}
                        >
                            {this.config.i18n.purchaseText}
                            {this.state.busy && <span className={'absolute inset-0 z-10 inline-flex justify-center items-center transition duration-300 ease-linear'}>
                                <Spinner centerMode={true} />
                            </span>}
                        </button>
                    </div>
                    <div className="w-full pt-4 lg:w-1/2 lg:pt-0 lg:pl-2">
                        <a href={this.config.assistanceUrl}
                            className="border border-solid border-grey h-11 px-4 sm:px-10 rounded-sm w-full text-center text-sm leading-snug inline-flex justify-center items-center relative transition duration-300 ease-linear bg-grey text-white md:text-[0.9375rem] hover:bg-green hover:border-green"
                        >
                            {this.config.i18n.assistanceText}

                            { this.state.assistanceBusy && <span className={'absolute inset-0 z-10 inline-flex justify-center items-center transition duration-300 ease-linear bg-grey'}>
                                <Spinner centerMode={true} />
                            </span>}
                        </a>
                    </div>
                </div>
            </div>
        </>
    }
}

export default PurchaseOptions
